<template>
	<div>
    <template v-if="type == 'monthly'">
      {{pricingPlan.months}}
      <translate v-if="pricingPlan.months == 1">Month</translate>
      <translate v-else>Months</translate>
      <span v-if="upgrade" class="ml-1">+ Upgrade de plano</span>
      <span
        v-if="priceInfo.price != priceInfo.priceWithDiscount"
        style="float: right; text-decoration:line-through"
        class="ml-2 grey--text"
      >{{priceInfo.price}}€</span>
      <span
        style="float: right"
        :class="priceInfo.price != priceInfo.priceWithDiscount ? 'green--text' : ''"
      >{{priceInfo.priceWithDiscount}}€</span>
      <!-- <span
        v-if="hasDiscount"
        style="float: right; text-decoration:line-through"
        class="ml-2 grey--text"
      >{{pricingPlan.price + pricingPlan.discount}}€</span>
      <span
        style="float: right"
        :class="hasDiscount ? 'green--text' : ''"
      >{{price}}€</span> -->
    </template>
    <template v-else>
      {{pricingPlan.days}}
      <translate v-if="pricingPlan.days == 1">Day</translate>
      <translate v-else>Days</translate>
      <span
        style="float: right; text-decoration:line-through"
        class="ml-2 grey--text"
      >{{pricingPlan.price}}€</span>
      <span
        style="float: right"
        class="green--text"
      >{{pricingPlan.priceWithDiscount}}€</span>
    </template>
	</div>
</template>

<script>
export default {
  name: "PricingPlan",
  props: ["pricingPlan", "module", "type", "plan", "upgrade"],
  data: () => ({}),
  computed: {
    priceInfo() {
      return this.$store.getters.monthlyPlanPrice(this.pricingPlan.months, this.plan);
    },
    hasDiscount() {
      if(this.pricingPlan.discount > 0) return true;
      if(this.$store.getters.hasOtherItems(this.module.code) && this.$store.getters.maxMonthsInCart >= this.pricingPlan.months) return true;
      return false;
    },
    price() {
      if(this.$store.getters.hasOtherItems(this.module.code)) {
				let maxMonths = this.$store.getters.maxMonthsInCart;
				if(this.pricingPlan.months <= maxMonths){
					let percentageToPay = 100 - this.module.discount_percentage;
					let price = this.pricingPlan.price * (percentageToPay/100);
					return Math.round((price + Number.EPSILON) * 100) / 100
				}
			}
			return this.pricingPlan.price;
    },
    priceDaily() {
      let percentageToPay = 100 - this.module.discount_percentage;
			let price = (this.module.daily_price * this.pricingPlan.days) * (percentageToPay/100);
			return Math.round((price + Number.EPSILON) * 100) / 100
    }
  }
}
</script>